import { sortCaret } from "../../../../../_metronic/_helpers";

const columns = ({ columnFormatters }) => [
  {
    dataField: "transactionId",
    text: "TRANSACTION ID",
    style: {
      minWidth: "110px"
    },
    formatter: columnFormatters.TransactionIdColumnFormatter
  },
  {
    dataField: "payxtremeStatus",
    text: "PAYXTREME STATUS",
    formatter: columnFormatters.StatusTypeFormatter,
    style: {
      minWidth: "200px"
    }
  },
  {
    dataField: "unityStatus",
    text: "UNITY STATUS",
    formatter: columnFormatters.UnityStatusTypeFormatter,
    style: {
      minWidth: "200px"
    }
  },
  {
    dataField: "createdAt",
    text: "TRANSACTION DATE",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "140px"
    },
    formatter: columnFormatters.DateTimeColumnFormatter
  },
  {
    dataField: "amount",
    text: "AMOUNT",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "110px"
    },
    formatter: columnFormatters.AmountColumnFormatter
  },
  {
    dataField: "fees",
    text: "TRANSACTION FEE",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "110px"
    },
    formatter: columnFormatters.CommissionColumnFormatter
  },
  {
    dataField: "totalAmount",
    text: "TOTAL AMOUNT",
    sort: false,
    sortCaret: sortCaret,
    style: {
      minWidth: "110px"
    },
    formatter: columnFormatters.TotalAmountColumnFormatter
  },
  {
    dataField: "senderId",
    text: "SENDER ID",
    sort: false,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.SenderIdColumnFormatter
  },
  {
    dataField: "senderFundingId",
    text: "SENDER FUNDING ID",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.SenderFundingIdColumnFormatter
  },
  {
    dataField: "senderFname",
    text: "SENDER FIRSTNAME",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.SenderFirstNameColumnFormatter
  },
  {
    dataField: "senderLname",
    text: "SENDER LASTNAME",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.SenderLastNameColumnFormatter
  },
  {
    dataField: "senderEmail",
    text: "SENDER EMAIL",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.SenderEmailColumnFormatter
  },
  {
    dataField: "senderCellNumber",
    text: "SENDER MOBILE NUMBER",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.SenderMobileColumnFormatter
  },
  {
    dataField: "receiverId",
    text: "RECEIVER ID",
    sort: false,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.ReceiverIdColumnFormatter
  },
  {
    dataField: "receiverFundingId",
    text: "RECEIVER FUNDING ID",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.ReceiverFundingIdColumnFormatter
  },
  {
    dataField: "receiverFname",
    text: "RECEIVER FIRSTNAME",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.ReceiverFirstNameColumnFormatter
  },
  {
    dataField: "receiverLname",
    text: "RECEIVER LASTNAME",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.ReceiverLastNameColumnFormatter
  },
  {
    dataField: "receiverEmail",
    text: "RECEIVER EMAIL",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.ReceiverEmailColumnFormatter
  },
  {
    dataField: "receiverCellnumber",
    text: "RECEIVER MOBILE NUMBER",
    sort: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.ReceiverMobileColumnFormatter
  },
  {
    dataField: "confirmation_id",
    text: "CONFIRMATION ID",
    // sort: true,
    // sortCaret: sortCaret,
    style: {
      minWidth: "110px"
    },
    formatter: columnFormatters.ConfirmationIDFormatter
  },
  // {
  //   dataField: "confirmation_date",
  //   text: "CONFIRMATION DATE",
  //   sort: true,
  //   sortCaret: sortCaret,
  //   style: {
  //     minWidth: "110px"
  //   },
  //   formatter: columnFormatters.ConfirmationDateFormatter
  // },
  {
    dataField: "fundVerificationDate",
    text: "FUND VERIFICATION DATE",
    sort: false,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.FundVerificationDateFormatter
  },
  {
    dataField: "sendReceiveFundsDate",
    text: "SEND/RECEIVE FUNDS DATE",
    sort: false,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.SendReceiveFundsDateFormatter
  },
  {
    dataField: "acceptRejectDate",
    text: "ACCEPT/REJECT DATE",
    sort: false,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    },
    formatter: columnFormatters.AcceptRejectDateFormatter
  },
  {
    dataField: "paymentDetailsLastFour",
    text: "Payment Details Last Four",
    sort: false,
    sortCaret: sortCaret,
    style: {
      minWidth: "110px"
    },
    formatter: columnFormatters.PaymentDetailsFormatter
  },
  {
    dataField: "holdingAccountType",
    text: "HOLDING ACCOUNT TYPE",
    sort: false,
    sortCaret: sortCaret,
    style: {
      minWidth: "200px"
    },
    formatter: columnFormatters.HoldingAccountTypeFormatter
  },
  {
    dataField: "scTransactionId",
    text: "SC-TRANSACTION ID #",
    // sort: true,
    // sortCaret: sortCaret,
    formatter: columnFormatters.SCTransactionFormatter,

    style: {
      minWidth: "110px"
    }
  },
  {
    dataField: "scTransactionType",
    text: "SC-TRANSACTION TYPE",
    formatter: columnFormatters.SCTransactionTypeFormatter,
    style: {
      minWidth: "200px"
    }
  },
  {
    dataField: "sc_address",
    text: "SC PROPERTY ADDRESS",
    formatter: columnFormatters.SCPropertyAddressFormatter,
    style: {
      minWidth: "200px"
    }
  },
  {
    dataField: "transactionMode",
    text: "DEPOSIT TYPE	",
    formatter: columnFormatters.DepositeTypeColumnFormatter,
    style: {
      minWidth: "110px"
    }
  }
  // {
  //   dataField: "transactionType",
  //   text: "TRANSACTION TYPE	",
  //   formatter: columnFormatters.TransactionTypeColumnFormatter,
  //   style: {
  //     minWidth: "110px"
  //   }
  // }

  // {
  //   dataField: "action",
  //   text: "Actions",
  //   formatter: columnFormatters.ActionsColumnFormatter,
  //   formatExtraData: {
  //     openReceiptDialog: transactionsReportUIProps.openReceiptDialog
  //   },
  //   classes: "text-right pr-0",
  //   headerClasses: "text-right pr-3",
  //   style: {
  //     minWidth: "80px"
  //   }
  // }
];

export default columns;
